import { render, staticRenderFns } from "./GreetingEditor.vue?vue&type=template&id=23abc93d&"
import script from "./GreetingEditor.vue?vue&type=script&lang=js&"
export * from "./GreetingEditor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports